'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = _react.PropTypes.shape({
  buttonBackgroundColor: _react.PropTypes.string,
  breakpointSettings: _react.PropTypes.objectOf(_react.PropTypes.shape({
    gutterSize: _react.PropTypes.string,
    itemsPerPage: _react.PropTypes.number,
    partiallyShowOffscreenItems: _react.PropTypes.bool,
    showDots: _react.PropTypes.bool,
    useTouchArrows: _react.PropTypes.bool
  }))
});


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/CarouselSettingShape.js
// module id = 361
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16